export interface IGeometry {
    type: string;
    coordinates: number[];
}

export interface IGeoJson {
    type: string;
		id?: any;
    geometry: IGeometry;
    properties?: any;
    $key?: string;
}

export class GeoJson implements IGeoJson {
  type = 'Feature';
  geometry: IGeometry;

  constructor(coordinates, public properties?) {
    this.geometry = {
      type: 'Point',
      coordinates: coordinates
    }
  }
}

export class FeatureCollection {
  type = 'FeatureCollection'
  constructor(public features: Array<GeoJson>) {}
}

export const MARKERS: IGeoJson[] = [
{
  "type": "Feature",
	"id" : 1,
  "geometry": {
    "type": "Point",
    "coordinates": [-2.0585433446040042, 42.38092131273111]
  },
  "properties": {
		"id" : 1,
    "content": "Hello World!",
		"icon": "marker-red",
		"iconSize": [5, 5]
  }
},
{
	"type": "Feature",
	"id" : 12351,
	"geometry": 	{
		"type": "Point",
		"coordinates": [-2.044522480456749, 42.3596491127368]
	},
	"properties":	{
		"id" : 12351,
		"date" : "08/08/2018",
		"category": "Mekanikoa",
		"title": "Sartaguda - Traktorea",
		"author" : "Beatriz Calvo",
		"href" : "",
		"content" : "Muxikak bildu eta traktorea badoa deskargatzera.<br\/><a href=\"http:\/\/www.culturanavarra.es\/eu\/landarte\">Landarte egitasmoaren laguntzarekin egindako grabaketa<\/a>.",
		"attachment" : "http://www.soinumapa.net/wp-content/uploads/2018/08/sartaguda_tractor.mp3",
		"image-url":"",
		"image" : ""
	}
},
{	"type": "Feature", "id" : 12330, "geometry": 	{"type": "Point","coordinates": [-2.038689716235922, 42.3658864254611]},	"properties":	{ "id" : 12330, "date" : "05/08/2018", "category": "Gizartea","title": "Sartaguda - Paraguayo bilketa", "author" : "Iñaki Martinez", "href" : "", "content" : "Uztaila iritsi bezala hasten dira Sartagudako nekazariak paraguayoak biltzen. Grabaketa honek lan horren berezko soinua erakusten du.<br\/><a href=\"http:\/\/www.culturanavarra.es\/eu\/landarte\">Landarte egitasmoaren laguntzarekin egindako grabaketa<\/a>.", "attachment" : "http://www.soinumapa.net/wp-content/uploads/2018/08/sartaguda_paraguayos.mp3","image-url":"","image" : "" }
  	},
{	"type": "Feature", "id":12436, "geometry": 	{"type": "Point","coordinates": [-2.0551689816199996, 42.38049250425786]},	"properties":	{ "id" : 12436, "date" : "27/07/2018", "category": "Gizartea","title": "Sartaguda - Ontziratzea", "author" : "Beatriz Calvo", "href" : "", "content" : "Babarrun txuri eta tomateak boteetan sartzeko prozesuaren, eta ondorengo egoste eta esterilizazio prozesuen soinuen grabaketa.", "attachment" : "http://www.soinumapa.net/wp-content/uploads/2018/09/sartaguda_embotado.mp3","image-url":"","image" : "" }
  	}
]

export class Map {}

export class Documento {
  constructor (
    public id: number,
    public coord: GeoJson,
    public title: string,
    public author: string,
    public email: string,
    public category: string,
    public file: File,
    public description?: string
  ) {}

  public setCoord(coord:number[]) {
    this.coord = new GeoJson(coord)
  }

  public setFile(file:File) {
    this.file = file;
  }
}



// WEBPACK FOOTER //
// ./src/app/map.ts